/*
* @Author: 王春岩 <Bolt>
* @Date:   2016-12-21 16:31:09
* @Last Modified by:   Bolt
* @Last Modified time: 2016-12-21 16:31:23
*/

'use strict';

import Vue from 'vue';
import Default from './components/Default.vue';
import VueLazyload from 'vue-lazyload';

Vue.use(VueLazyload);

window.$('.module_newcar').each((i, v) => {
    var $v = window.$(v);
    let app = new Vue(Object.assign(Default, {
        propsData: {
            dataId: $v.attr('data-id'),
            dataPositionindex: $v.attr('data-positionindex')
        }
    }));
    app.$mount(v);
});



// WEBPACK FOOTER //
// ./src/modules/newcar/index.js